module.exports = __webpack_public_path__ + "img/ccflowRightNextAdmin.06025cf7.png";